import { DependencyList, useEffect } from "react";
import { TUseTimeoutOptions, useTimeout } from "..";

const useDebounce = (
    callback: () => void,
    delay: number,
    dependencies: DependencyList,
    options: TUseTimeoutOptions = {}
) => {
    const { reset, clear } = useTimeout(callback, delay, options);
    useEffect(reset, [...dependencies, reset]);
    useEffect(clear, []);

    return { run: reset, clear };
};

export default useDebounce;
